module.exports = __webpack_public_path__ + "img/company4.bc6ad504.png";